import { useState, useEffect } from 'react';
import base64 from "base-64";
import ENV from "../env";


const useFetchGet = (url, param) => {
    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isRefresh, setRefresh] = useState(false);

    const doFetch = () => {
        setRefresh(!isRefresh)
    }

    const fetchData = async (url, options) => {
        setIsLoading(true);

        try {
            const updateUrl = `${url}`;
          
            const res = await fetch(updateUrl, options);
            const json = await res.json();
            setResponse(json);
            setIsLoading(false);
        } catch (error) {
            setError(error);
        }
    };


    useEffect(() => {

        const createToken = () => {
            Promise.all([
                localStorage.getItem('userId'),
                localStorage.getItem('sToken')
            ]).then(async (res) => {     
                let userId = JSON.parse(res[0]);
                let sToken = JSON.parse(res[1]);
                let header = base64.encode(`${userId}:${sToken}`);
                let security = `Basic ${header}`;
     
               
                const options = {
                    headers: {
                        'Accept': 'application/json',
                        'Security': security,
                        'Content-Type': 'application/json',
                    }
                };
                let newUrl = url;

                if(param){
                    newUrl = `${ENV.LOCUSB_API}/${newUrl}/${userId}/${param}`;
                }
                fetchData(newUrl, options);

            }).catch(err => {
                console.log("API call error", err)
            })
        }
        if (url) {
            createToken();
        }
    }, [isRefresh]);

    return { response , error, isLoading, doFetch };
};

export default useFetchGet;